/** Policy / GDPR APIs sometimes return numeric IDs or dates; never call `.trim()` blindly. */
export function asTrimmedString(value: unknown): string {
  if (value == null) return ''
  return String(value).trim()
}
